import React from "react";
import { useState, useEffect } from "react";
import { ViewProjectsSc } from "./index.sc";
import ProjectsCard from "../../Components/ProjectsCard";
import { useNavigate } from "react-router-dom";
import Navbar from "../../Components/Navbar";
import { Button } from "react-bootstrap";
import { getAllProjects } from "../../api/project/getProjects";
import { useAuthContext } from "../../hooks";
function Index() {
  const navigate = useNavigate();
  const auth = useAuthContext();
  const [getProjects, SetProjects] = useState<any[]>([]);
  const fetchAllProjects = async () => {
    await getAllProjects(auth?.userInfo?.orgs[0]?.id)
      .then((e) => {
        console.log(e);
        SetProjects(e);
      })
      .catch((e) => console.log(e));
  };

  useEffect(() => {
    fetchAllProjects();
  }, []);
  return (
    <>
      <ViewProjectsSc>
        <Button
          variant="primary"
          className="create-projects"
          onClick={() => navigate("createProjects")}
        >
          Add Projects
        </Button>
        <div className="projects-container">
          {getProjects?.map((data) => {
            return (
              <>
                <div
                  className="projects-cards"
                  onClick={() => navigate(`${data?.id}`)}
                >
                  <ProjectsCard
                    ProjectName={data?.name}
                    description={data?.description}
                    onClick={() => navigate(`${data?.id}`)}
                  />
                </div>
              </>
            );
          })}
        </div>
      </ViewProjectsSc>
    </>
  );
}

export default Index;
